import { apiClient } from "./api-client";
import type { LoginResponse } from "@/types/auth";

export async function login(username: string, password: string) {

  const response = await apiClient.post<LoginResponse, { username: string; password: string }>(
    "/auth/login",
    { username, password }
  );

  if (!response.success || !response.data) {
    throw new Error(response.message || "Invalid credentials");
  }

  return response.data;
}

export async function logout() {
  localStorage.removeItem("accessToken");
  localStorage.removeItem("refreshToken");
  localStorage.removeItem("user");
}

export async function refreshToken(refreshToken: string) {
  const response = await apiClient.post("/auth/refresh", { refreshToken });
  return response.data;
}

export async function getProfile() {
  const response = await apiClient.get("/auth/profile");
  return response.data;
}

export async function validateToken() {
  const response = await apiClient.get("/auth/validate");
  return response.data;
}

export async function ping() {
  const response = await apiClient.post("/auth/ping");
  return response.data;
}
